import { ChangeEvent, DragEvent, useState } from 'react';

import { Constants } from '../../../../../../constants/hiveNotices';
import { IconUploadMS } from '../../../../../../constants/icons';
import useSnackbar from '../../../../../../hooks/useSnackbar';
import {
  InsideBox,
  UploadBox,
  UploadIcon,
  UploadSubtitle,
  UploadTitle,
} from './styles';

interface DocumentUploadBoxProps {
  onFileSelect: (file: File) => void;
  inputId?: string;
  fullWidth?: boolean;
}

export function DocumentUploadBox({
  onFileSelect,
  inputId = 'documentUpload',
  fullWidth = false,
}: DocumentUploadBoxProps): JSX.Element {
  const [dragActive, setDragActive] = useState(false);
  const { handleSnackbar } = useSnackbar();

  const MAX_SIZE_BYTES = 10 * 1024 * 1024;

  const validateAndSelect = (file: File): void => {
    if (file.type !== 'application/pdf') {
      handleSnackbar(Constants.onlyPdfAllowed, true);
      return;
    }
    if (file.size > MAX_SIZE_BYTES) {
      handleSnackbar(Constants.fileTooLarge, true);
      return;
    }
    onFileSelect(file);
  };

  const handleDrag = (e: DragEvent<HTMLDivElement>): void => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  const handleDrop = (e: DragEvent<HTMLDivElement>): void => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    const file = e.dataTransfer.files?.[0];
    if (file) {
      validateAndSelect(file);
    }
  };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const file = e.target.files?.[0];
    if (file) {
      validateAndSelect(file);
      e.target.value = '';
    }
  };

  return (
    <UploadBox
      onDragEnter={handleDrag}
      onDragLeave={handleDrag}
      onDragOver={handleDrag}
      onDrop={handleDrop}
      sx={fullWidth ? { width: '100%' } : undefined}
    >
      <label htmlFor={inputId}>
        <input
          accept="application/pdf"
          id={inputId}
          type="file"
          style={{ display: 'none' }}
          onChange={handleFileChange}
        />
        {dragActive ? (
          <UploadTitle>Solte o arquivo aqui</UploadTitle>
        ) : (
          <InsideBox>
            <UploadIcon>{IconUploadMS}</UploadIcon>
            <UploadTitle>{Constants.dragAndDropgFile}</UploadTitle>
            <UploadSubtitle>{Constants.allowedFormat}</UploadSubtitle>
          </InsideBox>
        )}
      </label>
    </UploadBox>
  );
}
